<template>
  <div class="fixed w-full h-full flex justify-center items-center bg-[rgba(53,53,53,0.43)] z-50 top-0 left-0">
    <div class="relative flex flex-col w-[659px] h-fit rounded bg-white shadow-modal overflow-hidden m-5 xl:m-0">
      <!-- Close btn -->
      <button
          class="absolute left-[25px] top-[27px] w-9 h-9 rounded flex justify-center items-center text-grays-700"
          @click="toggleShow"
      >
        <span class="material-symbols-rounded">close</span>
      </button>
      <!-- Content -->
      <section class="flex flex-col gap-[35px] pt-[50px] xl:pt-[106px] pb-[20px] xl:pb-[57px] px-[20px] xl:px-[104px] text-center">
        <h2 class="text-primary-900 text-2xl font-bold">הרשמה מלאה</h2>
        <p class="text-grays-900 text-base font-regular">דרך ארוכה אבל קצרה.
          מאוחר יותר נצטרך עוד כמה פרטים
          תוכלו להשלים אותם כאן ועכשיו או בהמשך</p>
      </section>
      <!-- Action -->
      <section class="flex flex-row justify-center gap-[8px] py-[23px] px-4 xl:px-0 border-t border-grays-400 ">
        <button-text @click="handleCompleteLater">
          נחזור לזה בהמשך
        </button-text>
        <button-primary @click="handleCompleteNow">
          להשלים וגמרנו
        </button-primary>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "complete-registration-now-modal",
  methods: {
    toggleShow() {
      this.$emit("toggle-show-complete-registration-modal")
    },
    handleCompleteNow() {
      this.$router.push("/complete-registration")
    },
    handleCompleteLater() {
      this.$router.push("/send-email-verification")
    }
  }
}
</script>

<style>

</style>